module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/profession_type02.d901acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/profession_type02.jpg
// module id = 81/G
// module chunks = 0